module.exports = __webpack_public_path__ + "img/person-seat.fc8acec2.svg";